import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dc0b515"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-slateGray" }

import { computed, onMounted, watch } from 'vue'
import { MJPSection, MJPSectionData } from './types'
import SectionBase from '../general/SectionBase.vue'
import SectionPage from '../general/SectionPage.vue'
import TextCard from '../general/TextCard.vue'
import useLanguage from '@/composables/useLanguage'
import ResponsiveBackgroundImage from '../general/ResponsiveBackgroundImage.vue'
import BottomGradient from '../general/BottomGradient.vue'

interface Props {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IntentToHealSection',
  props: {
    sectionData: null,
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    currentPage: null,
    forward: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  forward: boolean
}


const text = useLanguage(props.currentSection)

const sectionIsActive = computed(() => {
  return props.currentSection == props.sectionData.section
})

const pageRangeIsActive = (lo, hi) => {
  if (sectionIsActive.value && props.currentSectionHasLoaded) {
    return props.currentPage >= lo && props.currentPage <= hi
  } else {
    return false
  }
}

const focusCurrentTextCard = () => {
  ;(
    document.querySelector(
      `#${props.currentSection}-${props.currentPage + 1} .text-card`
    ) as HTMLElement
  )?.focus()
}

onMounted(() => {
  focusCurrentTextCard()
})

watch(
  () => props.currentPage,
  (currentValue, previousValue) => {
    focusCurrentTextCard()
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveBackgroundImage, {
      id: "intentToHeal-bg-1",
      dir: "mjp",
      sm: "intentToHeal-bg-1-sm.jpg",
      md: "intentToHeal-bg-1-md.jpg",
      lg: "intentToHeal-bg-1-lg.jpg",
      alt: _unref(text).visitorDogAlt,
      isActive: pageRangeIsActive(0, 0)
    }, null, 8, ["alt", "isActive"]),
    _createVNode(ResponsiveBackgroundImage, {
      id: "intentToHeal-bg-2",
      dir: "mjp",
      sm: "intentToHeal-bg-2-sm.jpg",
      md: "intentToHeal-bg-2-md.jpg",
      lg: "intentToHeal-bg-2-lg.jpg",
      alt: _unref(text).wideViewAlt,
      isActive: pageRangeIsActive(1, 99)
    }, null, 8, ["alt", "isActive"]),
    _createVNode(BottomGradient),
    _createVNode(SectionBase, {
      thisSection: props.sectionData.section,
      currentSection: props.currentSection,
      currentSectionHasLoaded: props.currentSectionHasLoaded,
      currentPage: props.currentPage,
      forward: props.forward,
      position: props.sectionData.focalPoint
    }, {
      default: _withCtx(() => [
        _createVNode(SectionPage, {
          id: `${props.sectionData.section}-1`,
          class: "flex items-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(TextCard, {
              text: _unref(text).investment,
              class: "md:mx-200px",
              enclosed: true
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["id"]),
        _createVNode(SectionPage, {
          id: `${props.sectionData.section}-2`,
          class: "flex items-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(TextCard, {
              text: _unref(text).impact,
              class: "md:mx-200px",
              enclosed: true
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 8, ["thisSection", "currentSection", "currentSectionHasLoaded", "currentPage", "forward", "position"])
  ]))
}
}

})